import { useIntersectionObserver } from "usehooks-ts";

export const useBottomPanel = () => {
  const { isIntersecting, ref: heroRef } = useIntersectionObserver({
    threshold: 0.2,
  });

  const showBottomPanel = !isIntersecting;

  return { heroRef, showBottomPanel };
};
